var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper notificationContainerWrapper"},[_c('div',{staticClass:"top notificationContainer"},[_c('img',{attrs:{"src":"/assets/img/info.svg"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }